import { configure, makeAutoObservable } from 'mobx';

import { NotificationsStore } from '../../NotificationsStore';
import { TourAveragesData } from 'types/admin/tourAverages';
import TourAveragesEditorService from '../../../services/Admin/Editors/TourAveragesEditorService';
import { getErrorMessage } from 'utilities/ErrorHelper';

configure({ enforceActions: 'never' });

export const clubsDefaults = {
  driver: null,
  threeWood: null,
  fiveWood: null,
  hybrid: null,
  threeIron: null,
  fourIron: null,
  fiveIron: null,
  sixIron: null,
  sevenIron: null,
  eightIron: null,
  nineIron: null,
  pitchingWedge: null,
};

export class TourAveragesEditorStore {
  private tourAveragesEditorService: TourAveragesEditorService;
  private ns: NotificationsStore;

  constructor(tourAveragesEditorService: TourAveragesEditorService, notificationStore: NotificationsStore) {
    makeAutoObservable(this); //This line will automatically decorate each store property with 'observable' and each method with 'action'.
    this.tourAveragesEditorService = tourAveragesEditorService;
    this.ns = notificationStore;
  }

  tourAveragesData: TourAveragesData = {
    id: '',
    year: null,
    pga: [],
    lpga: [],
  };

  cleanTourParameterData = {
    parameterId: '',
    unit: '',
  };
  newTourParameterData = { ...this.cleanTourParameterData };

  isLoading: boolean = false;

  getTourAverages = async () => {
    try {
      this.isLoading = true;
      const response = await this.tourAveragesEditorService.getTourAverages();
      if (response !== 'noContent') {
        this.tourAveragesData = response;
      }
    } catch (ex) {
      this.ns.addToast('error', getErrorMessage(ex), 'error');
    }
    this.isLoading = false;
  };

  saveNewTourAveragesAndRefreshTable = async () => {
    try {
      this.isLoading = true;
      delete this.tourAveragesData.id;
      await this.tourAveragesEditorService.saveNewTourAverages(this.tourAveragesData);
      await this.getTourAverages();
      this.ns.addToast('success', 'Table has been saved successfully', 'success');
    } catch (ex) {
      this.ns.addToast('error', getErrorMessage(ex), 'error');
    }
    this.isLoading = false;
  };

  updateTourAveragesAndRefreshTable = async () => {
    try {
      this.isLoading = true;
      await this.tourAveragesEditorService.updateTourAverages(this.tourAveragesData);
      await this.getTourAverages();
      this.ns.addToast('success', 'Table has been saved successfully', 'success');
    } catch (ex) {
      this.ns.addToast('error', getErrorMessage(ex), 'error');
    }
    this.isLoading = false;
  };
}

export default TourAveragesEditorStore;
